import { render, staticRenderFns } from "./CategoryFilter.vue?vue&type=template&id=1ee1ef90&"
import script from "./CategoryFilter.vue?vue&type=script&lang=js&"
export * from "./CategoryFilter.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFilter.vue?vue&type=style&index=0&id=1ee1ef90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports